import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './AgentResidualsListItem.scss';

export default class AgentResidualsListItem extends Component {
    static propTypes = {
        item: PropTypes.any
    };

    renderAgentResidualsMerchantName(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    renderAgentResidualsRepCode(repCode) {
        return repCode ? repCode : 'No RepCode';
    }

    render() {
        const agentResiduals = this.props.item;

        return (
            <div className="agent-residuals-list-item">
                <div className="agent-residuals-list-item-left">
                    <span className="agent-residuals-merchant-name">
                        {this.renderAgentResidualsMerchantName(agentResiduals.merchantName)}
                    </span>
                    <span className="agent-residuals-main-repcode">
                        {this.renderAgentResidualsRepCode(agentResiduals.mainRepCode)}
                    </span>
                </div>
                <div className="agent-residuals-list-item-right">
                    <span className="agent-residuals-agent-residual">
                        <ColorDollarAmountCell amount={agentResiduals.agentResidual}/>
                    </span>
                </div>
            </div>
        );
    }
}
